import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";

import { connect, useSelector } from "react-redux";


import {
  Table,
  Button,
  Badge,
  Modal,
  Form,
  InputGroup,
  Dropdown,
  DropdownButton,
  Row,
  Col,
  Card,
  Spinner,
  Tabs,
  Tab,
  Pagination,
  Alert,
  OverlayTrigger,
  Tooltip,
  ButtonGroup,
} from "react-bootstrap";
import {
  BellFill,
  CheckCircleFill,
  XCircleFill,
  FilterCircle,
  SortDown,
  SortUp,
  FileEarmarkPdf,
  FileEarmarkExcel,
  ArrowClockwise,
  Info,
  Trash,
  PinFill,
  Clock,
  GearFill,
  PlusCircle,
  Tools,
  Person,
  Calendar2Week,
} from "react-bootstrap-icons";
import { toast } from "react-toastify";
import "./CSS/Alarm.css";
import { CSVLink } from "react-csv";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AlarmPdfDocument from "./AlarmPdfDocument";
import { useTranslation } from "react-i18next";
import AlarmDetailTabs from "../AlarmDetailTabs";

const API_BASE_URL = "https://rmms-metis-engine.azurewebsites.net/api";
let ucerId_ = sessionStorage.getItem("TEMPCOM");
if (ucerId_) {
  ucerId_ = Number(JSON.parse(ucerId_));
}
const ucerId = ucerId_;
// İş emri oluşturma fonksiyonu
const createAlarmWorkOrder = async (
  alarmId,
  title,
  description,
  assignedUserId,
  dueDate,
  priority = "Medium",
  companyId = ucerId,
  location = "",
  equipment = ""
) => {
  try {
    const request = await fetch(`${API_BASE_URL}/Alarm/createWorkOrder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        AlarmId: alarmId,
        Title: title,
        Description: description,
        Priority: priority,
        AssignedUserId: assignedUserId || null,
        DueDate: dueDate || null,
        CreatedByUserId: 0, // buraya kullanıcı adı gelecek
        CompanyId: companyId,
        Location: location,
        Equipment: equipment,
      }),
    });

    const response = await request.json();

    if (request.status === 200) {
      toast.success(`Alarm #${alarmId} için iş emri oluşturuldu`);
      return response.WorkOrderId;
    }

    return null;
  } catch (err) {
    console.error("İş emri oluşturulurken hata oluştu:", err);
    toast.error("İş emri oluşturulurken bir hata oluştu.");
    return null;
  }
};
// Enhanced CreateWorkOrderForm with file attachments
const CreateWorkOrderForm = React.memo(
  ({ alarmId, onWorkOrderCreated, onCancel, onModalClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [localAttachments, setLocalAttachments] = useState([]);
    const [formData, setFormData] = useState({
      title: "",
      description: "",
      priority: "Medium",
      assignedUserId: "",
      dueDate: "",
      location: "",
      equipment: "",
    });

    // Upload file to work order - defined inside the component to access it
    const uploadFileToWorkOrder = async (workOrderId, file) => {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(
          `${API_BASE_URL}/WorkOrder/${workOrderId}/attachments`,
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          return true;
        }
        return false;
      } catch (error) {
        console.error("Dosya yüklenirken hata:", error);
        return false;
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      try {
        const workOrderId = await createAlarmWorkOrder(
          alarmId,
          formData.title,
          formData.description,
          formData.assignedUserId || null,
          formData.dueDate || null,
          formData.priority,
          ucerId,
          formData.location,
          formData.equipment
        );

        if (workOrderId) {
          // Dosya eklerini yükle
          if (localAttachments.length > 0) {
            const uploadPromises = localAttachments.map((file) =>
              uploadFileToWorkOrder(workOrderId, file)
            );

            await Promise.all(uploadPromises);
          }

          toast.success("İş emri başarıyla oluşturuldu");

          // Callback fonksiyonu çağırarak işlemi bildir ve modal'ı kapat
          if (typeof onWorkOrderCreated === "function") {
            onWorkOrderCreated(workOrderId);
          }
          if (typeof onModalClose === "function") {
            onModalClose();
          }
        }
      } catch (error) {
        console.error("İş emri oluşturma hatası:", error);
        toast.error("İş emri oluşturulurken bir hata oluştu: " + error.message);
      } finally {
        setIsLoading(false);
      }
    };

    // Form alanı değiştirme
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle file attachment
    const handleFileChange = (e) => {
      if (e.target.files) {
        const newFiles = Array.from(e.target.files);
        setLocalAttachments((prev) => [...prev, ...newFiles]);
      }
    };

    // Remove an attachment
    const removeAttachment = (index) => {
      setLocalAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    return (
      <Form onSubmit={handleSubmit}>
        <h5 className="mb-3">Yeni İş Emri Oluştur</h5>

        <Form.Group className="mb-3">
          <Form.Label>Başlık *</Form.Label>
          <Form.Control
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Açıklama</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </Form.Group>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Öncelik</Form.Label>
              <Form.Select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
              >
                <option value="Low">Düşük</option>
                <option value="Medium">Orta</option>
                <option value="High">Yüksek</option>
                <option value="Critical">Kritik</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Atanacak Kişi *</Form.Label>
              <Form.Control
                type="text"
                name="assignedUserId"
                value={formData.assignedUserId}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Son Tarih</Form.Label>
              <Form.Control
                type="date"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Konum</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Ekipman</Form.Label>
          <Form.Control
            type="text"
            name="equipment"
            value={formData.equipment}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Dosya Ekle</Form.Label>
          <Form.Control type="file" multiple onChange={handleFileChange} />

          {localAttachments.length > 0 && (
            <div className="mt-2">
              <h6>Eklenecek Dosyalar:</h6>
              <ul className="list-group">
                {localAttachments.map((file, index) => (
                  <li
                    key={index}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    {file.name}
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeAttachment(index)}
                    >
                      <XCircleFill />
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Form.Group>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button
            variant="outline-secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            İptal
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
                İşleniyor...
              </>
            ) : (
              <>İş Emri Oluştur</>
            )}
          </Button>
        </div>
      </Form>
    );
  }
);

// Work Order Creation Modal bileşeni
const WorkOrderCreationModal = ({
  show,
  onHide,
  alarmStatusChangeRequest,
  onWorkOrderCreated,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>İş Emri Oluştur</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {alarmStatusChangeRequest && (
          <Alert variant="info">
            <Alert.Heading>İş Emri Gerekli</Alert.Heading>
            <p>
              Alarm #{alarmStatusChangeRequest.alarm.id} için "
              {alarmStatusChangeRequest.targetStatus}" durumuna geçmek için bir
              iş emri oluşturulması gerekmektedir.
            </p>
          </Alert>
        )}
        <CreateWorkOrderForm
          alarmId={alarmStatusChangeRequest?.alarm.id}
          onWorkOrderCreated={onWorkOrderCreated}
          onCancel={onCancel}
          onModalClose={onHide}
        />
      </Modal.Body>
    </Modal>
  );
};

// Closing Notes Modal bileşeni
const ClosingNotesModal = ({ show, onHide, notes, setNotes, onSubmit }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Çözüm Notları</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Çözüm açıklaması giriniz *</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Alarm nasıl çözüldü? Hangi işlemler yapıldı?"
            required
          />
          <Form.Text className="text-muted">
            Alarmı kapatmak için çözüm notlarını girmeniz gerekmektedir.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          İptal
        </Button>
        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={!notes || notes.trim() === ""}
        >
          Alarmı Kapat
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Alarm = (props) => {
  const { t } = useTranslation();

  const [alarm_yazma, Set_alarm_yazma] = useState(false)
  const [alarm_silme, Set_alarm_silme] = useState(false)

  useEffect(() => {
    if (props.yetkilendirme && props.uid !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      if (newObj !== undefined) {
        if (newObj["Alarm"]["Y"] === "t") {

          Set_alarm_yazma(true)
        } else {
          Set_alarm_yazma(false);

        }

        if (newObj["Alarm"]["S"] === "t") {

          Set_alarm_silme(true)
        } else {
          Set_alarm_silme(false);

        }
      }

    }
  }, [])

  // Bootstrap'i sadece bu bileşene özgü olarak import etme
  useEffect(() => {
    // Bootstrap CSS'i dinamik olarak ekle
    const bootstrapCSS = document.createElement("link");
    bootstrapCSS.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    bootstrapCSS.rel = "stylesheet";
    bootstrapCSS.integrity =
      "sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN";
    bootstrapCSS.crossOrigin = "anonymous";
    bootstrapCSS.id = "alarm-bootstrap-css";
    document.head.appendChild(bootstrapCSS);

    // Bootstrap JS'i dinamik olarak ekle
    const bootstrapJS = document.createElement("script");
    bootstrapJS.src =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js";
    bootstrapJS.integrity =
      "sha384-C6RzsynM9kWDrMNeT87bh95OGNyZPhcTNXj1NW7RuBCsyN/o0jlpcV8Qyq46cDfL";
    bootstrapJS.crossOrigin = "anonymous";
    bootstrapJS.id = "alarm-bootstrap-js";
    document.body.appendChild(bootstrapJS);

    const customCSS = document.createElement("style");
    customCSS.id = "alarm-custom-css";
    customCSS.textContent = `
    header {
      position: fixed;
      z-index: 999;
      width: 90% !important;
    }
  `;
    document.head.appendChild(customCSS);

    // Cleanup fonksiyonu - bileşen unmount olduğunda Bootstrap'i kaldır
    return () => {
      document.getElementById("alarm-bootstrap-css")?.remove();
      document.getElementById("alarm-bootstrap-js")?.remove();
      document.getElementById("alarm-custom-css")?.remove();
    };
  }, []);

  const [alarmList, setAlarmList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true); // For first load
  const [selectedAlarm, setSelectedAlarm] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showPdfLink, setShowPdfLink] = useState(false); // PDF butonuna basıldığında true olacak
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [userInitiatedPageChange, setUserInitiatedPageChange] = useState(false);
  const [userInitiatedFilterChange, setUserInitiatedFilterChange] =
    useState(false);
  const isFirstRender = useRef(true);

  // Enhanced filter state with pagination
  const [filter, setFilter] = useState({
    status: "all", // all, confirmed, unconfirmed
    priority: "all", // all, high, medium, low
    alarmStatus: "all", // all, Open, InProgress, Closed
    search: "",
    dateRange: {
      start: null,
      end: null,
    },
  });

  // Separate pagination state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  });

  const [sorting, setSorting] = useState({
    field: "date",
    direction: "desc",
  });

  // New state for workflow enhancement
  const [alarmStatusChangeRequest, setAlarmStatusChangeRequest] =
    useState(null);
  const [showWorkOrderCreationModal, setShowWorkOrderCreationModal] =
    useState(false);
  const [showClosingNotesModal, setShowClosingNotesModal] = useState(false);
  const [closingNotes, setClosingNotes] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isFilterChanging, setIsFilterChanging] = useState(false);

  // Statistics state
  const [stats, setStats] = useState({
    total: 0,
    unconfirmed: 0,
    critical: 0,
    warning: 0,
    high: 0,
    info: 0,
    open: 0,
    inProgress: 0,
    closed: 0,
  });
  // Create a memoized request object for fetching alarms
  const createAlarmRequest = useCallback(() => {
    return {
      companyId: ucerId,
      status: filter.status,
      priority: filter.priority,
      alarmStatus: filter.alarmStatus,
      search: filter.search,
      startDate: filter.dateRange.start,
      endDate: filter.dateRange.end,
      page: pagination.currentPage,
      pageSize: pagination.itemsPerPage,
      sortField: sorting.field,
      sortDirection: sorting.direction,
    };
  }, [
    ucerId,
    filter,
    pagination.currentPage,
    pagination.itemsPerPage,
    sorting,
  ]);

  // Fetch alarms with server-side filtering, sorting and pagination
  const fetchAlarms = useCallback(
    async (isInitial = false) => {
      if (isInitial) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }

      const currentRequest = { ...createAlarmRequest() };
      const savedPriority = filter.priority;

      if (savedPriority !== "all") {
        currentRequest.priority = "all";
        currentRequest.page = 1;
        currentRequest.pageSize = 1000;
      }

      console.log("Fetching alarms with modified request:", currentRequest);

      try {
        const request = await fetch(`${API_BASE_URL}/Alarm/GetAlarmList`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(currentRequest),
        });

        const response = await request.json();

        console.log("API response:", {
          currentPage: currentRequest.page,
          pageSize: currentRequest.pageSize,
          returnedCount: response?.alarms?.length || 0,
          totalCount: response?.totalCount,
          totalPages: response?.totalPages,
        });

        if (request.status === 200) {
          // API'den gelen alarmları işle ve öncelik değerlerini hesapla
          let alarmsWithPriority = response.alarms.map((alarm) => ({
            ...alarm,
            priority: getPriorityFromStatusCode(alarm.statusCode),
            timeElapsed: getTimeElapsed(alarm.date),
            alarmStatus: alarm.alarmStatus || "Open", // Default 'Open' value
          }));

          // İstemci tarafında öncelik filtrelemesi
          let filteredAlarms = alarmsWithPriority;
          if (savedPriority !== "all") {
            console.log(`Önceliğe göre filtreleme yapılıyor: ${savedPriority}`);
            console.log(
              `Filtreleme öncesi toplam alarm sayısı: ${alarmsWithPriority.length}`
            );

            filteredAlarms = alarmsWithPriority.filter(
              (alarm) => alarm.priority === savedPriority
            );

            console.log(
              `Filtreleme sonrası alarm sayısı: ${filteredAlarms.length}`
            );

            // Sayfalamayı manuel olarak uygula
            const startIndex =
              (pagination.currentPage - 1) * pagination.itemsPerPage;
            const endIndex = startIndex + pagination.itemsPerPage;

            // Filtrelenmiş alarmları sayfalama ile sınırla
            const pagedAlarms = filteredAlarms.slice(startIndex, endIndex);
            console.log(
              `Sayfalama sonrası gösterilen alarm sayısı: ${pagedAlarms.length}`
            );

            setAlarmList(pagedAlarms);

            // Filtrelenmiş toplam kayıt sayısı ve sayfa sayısını güncelle
            setPagination((prev) => ({
              ...prev,
              totalItems: filteredAlarms.length,
              totalPages: Math.ceil(
                filteredAlarms.length / pagination.itemsPerPage
              ),
            }));
          } else {
            // Öncelik filtresi yoksa normal API yanıtını kullan
            setAlarmList(alarmsWithPriority);

            // API'den dönen sayfalama bilgilerini kullan
            setPagination((prev) => ({
              ...prev,
              totalItems: response.totalCount,
              totalPages: response.totalPages,
            }));
          }

          // İstatistikleri güncelle
          fetchAlarmStats();
        } else {
          toast.error(
            "Alarmlar yüklenirken bir hata oluştu: " + request.statusText
          );
        }
      } catch (err) {
        console.error("Alarmlar getirilirken hata oluştu:", err);
        toast.error("Alarmlar yüklenirken bir hata oluştu.");
      } finally {
        setLoading(false);
        if (isInitial) {
          setInitialLoading(false);
        }
      }
    },
    [
      createAlarmRequest,
      pagination.currentPage,
      pagination.itemsPerPage,
      filter.priority,
    ]
  );

  // İstatistikleri güncelleme yardımcı fonksiyonu - retry mantığını kaldırdık
  const updateStats = async () => {
    try {
      await fetchAlarmStats();
    } catch (error) {
      console.error("İstatistik güncellenirken hata:", error);
      // Retry yapmadan hata durumunu kabul ediyoruz
    }
  };

  // Load initial data when component mounts
  useEffect(() => {
    if (isFirstRender.current) {
      fetchAlarms(true); // true means initial loading
      isFirstRender.current = false;
    }
  }, []);

  useEffect(() => {
    if (!initialLoading && userInitiatedFilterChange) {
      console.log("Filter changed by user - resetting to page 1");

      // Reset page to 1 without triggering fetchAlarms
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
      }));

      // Clear the flag
      setUserInitiatedFilterChange(false);

      // Fetch data with the new filter and page 1
      // We have to use a timeout to ensure the pagination state is updated first
      setTimeout(() => {
        fetchAlarms();
      }, 0);
    }
  }, [userInitiatedFilterChange, initialLoading, fetchAlarms]);

  useEffect(() => {
    if (!initialLoading && userInitiatedPageChange) {
      console.log("Page changed by user to:", pagination.currentPage);

      // Clear the flag
      setUserInitiatedPageChange(false);

      // Fetch data for the new page
      fetchAlarms();
    }
  }, [
    userInitiatedPageChange,
    pagination.currentPage,
    initialLoading,
    fetchAlarms,
  ]);

  // Re-fetch when pagination changes
  useEffect(() => {
    // Skip during initial loading
    if (initialLoading) return;

    // This ensures we don't fetch twice when filter changes
    const timer = setTimeout(() => {
      fetchAlarms().then(() => {
        // Reset the filter change flag after fetching completes
        setIsFilterChanging(false);
      });
    }, 0);

    return () => clearTimeout(timer);
  }, [pagination.currentPage, isFilterChanging, initialLoading, fetchAlarms]);

  // Alarm onaylama fonksiyonu - optimized to update state locally
  const updateAlarm = async (item, isConfirmed) => {
    try {
      setLoading(true);

      const request = await fetch(`${API_BASE_URL}/Alarm/updateConfirmStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          ID: item.id,
          Confirm_: isConfirmed ? 1 : 0,
          CompanyID: ucerId,
          Notes: item.notes || "",
          AssignedTo: item.assignedTo || "",
        }),
      });

      const response = await request.json();

      if (request.status === 200) {
        toast.success(
          isConfirmed
            ? `Alarm #${item.id} onaylandı`
            : `Alarm #${item.id} onayı kaldırıldı`
        );

        if (response.Success && response.Alarm) {
          // Update just the specific alarm in the list
          setAlarmList((prevAlarms) =>
            prevAlarms.map((alarm) =>
              alarm.id === item.id
                ? {
                  ...response.Alarm,
                  priority: getPriorityFromStatusCode(
                    response.Alarm.statusCode
                  ),
                  timeElapsed: getTimeElapsed(response.Alarm.date),
                  alarmStatus: response.Alarm.alarmStatus || "Open",
                }
                : alarm
            )
          );

          // Also update the selected alarm if it's the same one
          if (selectedAlarm && selectedAlarm.id === item.id) {
            setSelectedAlarm((prev) => ({
              ...prev,
              confirm_: isConfirmed ? 1 : 0,
            }));
          }

          // Update stats with a small delay to ensure server has processed the change
          setTimeout(() => {
            fetchAlarmStats();
          }, 300);
        } else {
          // If we don't get the updated alarm back, fallback to full refresh
          fetchAlarms();
        }
      }

      setLoading(false);
    } catch (err) {
      console.error("Alarm güncellenirken hata oluştu:", err);
      toast.error("Alarm güncellenirken bir hata oluştu.");
      setLoading(false);
    }
  };

  const getStatusDisplayText = (statusCode) => {
    switch (statusCode) {
      case "Open":
        return "Açık";
      case "InProgress":
        return "İlgileniliyor";
      case "Closed":
        return "Çözüldü";
      default:
        return statusCode;
    }
  };

  // Enhanced Alarm Status Update Function with workflow logic
  const updateAlarmStatus = async (item, newStatus, notes = "") => {
    try {
      // If transitioning to InProgress and no work order exists, prompt for work order creation
      if (newStatus === "InProgress") {
        const workOrder = await fetchWorkOrderByAlarmId(item.id);

        if (!workOrder) {
          // Show modal to create work order instead of directly changing status
          toast.info(
            `Alarmı "İlgileniliyor" durumuna geçirmek için iş emri oluşturulmalıdır.`
          );

          // Store the desired status change for when work order is created
          setAlarmStatusChangeRequest({
            alarm: item,
            targetStatus: newStatus,
          });

          // Open the work order creation modal
          setShowWorkOrderCreationModal(true);
          return;
        }
      }

      // If transitioning to Closed, require notes
      if (newStatus === "Closed" && (!notes || notes.trim() === "")) {
        // Show modal to collect closing notes
        setAlarmStatusChangeRequest({
          alarm: item,
          targetStatus: newStatus,
        });

        setShowClosingNotesModal(true);
        return;
      }

      const statusText = getStatusDisplayText(newStatus); // Görünen durum metnini al
      const oldStatusText = getStatusDisplayText(item.alarmStatus || "Open"); // Eski durumun metni

      const logDescription = notes
        ? `Durum "${oldStatusText}" durumundan "${statusText}" durumuna değiştirildi. Not: ${notes}`
        : `Durum "${oldStatusText}" durumundan "${statusText}" durumuna değiştirildi.`;

      setLoading(true);

      const request = await fetch(`${API_BASE_URL}/Alarm/updateStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          AlarmId: item.id,
          NewStatus: newStatus,
          UserId: props.userId || 0,
          Description: logDescription,
        }),
      });

      const response = await request.json();

      if (request.status === 200) {
        toast.success(
          `Alarm #${item.id} durumu "${newStatus}" olarak güncellendi`
        );

        if (response.Success && response.Alarm) {
          // Update just the specific alarm in the list
          setAlarmList((prevAlarms) =>
            prevAlarms.map((alarm) =>
              alarm.id === item.id
                ? {
                  ...response.Alarm,
                  priority: getPriorityFromStatusCode(
                    response.Alarm.statusCode
                  ),
                  timeElapsed: getTimeElapsed(response.Alarm.date),
                  alarmStatus: response.Alarm.alarmStatus || "Open",
                }
                : alarm
            )
          );

          // Also update the selected alarm if it's the same one
          if (selectedAlarm && selectedAlarm.id === item.id) {
            setSelectedAlarm((prev) => ({
              ...prev,
              alarmStatus: newStatus,
            }));
          }

          // Directly update statistics based on status change
          setStats((prevStats) => {
            const newStats = { ...prevStats };

            // Decrement previous status count
            if (item.alarmStatus === "Open")
              newStats.open = Math.max(0, newStats.open - 1);
            else if (item.alarmStatus === "InProgress")
              newStats.inProgress = Math.max(0, newStats.inProgress - 1);
            else if (item.alarmStatus === "Closed")
              newStats.closed = Math.max(0, newStats.closed - 1);

            // Increment new status count
            if (newStatus === "Open") newStats.open += 1;
            else if (newStatus === "InProgress") newStats.inProgress += 1;
            else if (newStatus === "Closed") newStats.closed += 1;

            return newStats;
          });

          // Also fetch the latest stats after a delay to ensure accuracy
          setTimeout(() => {
            fetchAlarmStats();
          }, 300);
        } else {
          // If we don't get the updated alarm back, fallback to full refresh
          fetchAlarms();
        }
      }

      setLoading(false);
    } catch (err) {
      console.error("Alarm durumu güncellenirken hata oluştu:", err);
      toast.error("Alarm durumu güncellenirken bir hata oluştu.");
      setLoading(false);
    }
  };
  // Alarmlar için log kayıtlarını getiren fonksiyon
  const fetchAlarmLogs = async (alarmId) => {
    try {
      const request = await fetch(`${API_BASE_URL}/Alarm/getLogs/${alarmId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (request.status === 200) {
        const logs = await request.json();
        return logs;
      }

      return [];
    } catch (err) {
      console.error("Alarm logları getirilirken hata oluştu:", err);
      toast.error("Alarm logları yüklenirken bir hata oluştu.");
      return [];
    }
  };

  // İş emri detaylarını getirme fonksiyonu
  const fetchWorkOrderById = async (workOrderId) => {
    try {
      const request = await fetch(`${API_BASE_URL}/WorkOrder/${workOrderId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      if (request.status === 200) {
        const workOrder = await request.json();
        return workOrder;
      }

      return null;
    } catch (err) {
      console.error("İş emri detayları getirilirken hata oluştu:", err);
      return null;
    }
  };

  // İş emri durumunu güncelleme fonksiyonu
  const updateWorkOrderStatus = async (workOrderId, newStatus, notes = "") => {
    try {
      const request = await fetch(`${API_BASE_URL}/WorkOrder/updateStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          WorkOrderId: workOrderId,
          NewStatus: newStatus,
          UserId: props.userId || 0,
          Description: notes,
        }),
      });

      if (request.status === 200) {
        toast.success(`İş emri durumu "${newStatus}" olarak güncellendi`);
        return true;
      }

      return false;
    } catch (err) {
      console.error("İş emri durumu güncellenirken hata oluştu:", err);
      toast.error("İş emri durumu güncellenirken bir hata oluştu.");
      return false;
    }
  };

  const fetchAlarmStats = useCallback(async () => {
    if (!ucerId) return;

    try {
      const statsRequest = await fetch(
        `${API_BASE_URL}/Alarm/GetAlarmStats?companyId=${ucerId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log(statsRequest)

      if (statsRequest.status === 200) {
        const statsData = await statsRequest.json();
        // Set statistics based on returned data
        setStats({
          total: statsData.total || 0,
          unconfirmed: statsData.unconfirmed || 0,
          critical: statsData.critical || 0,
          warning: statsData.warning || 0,
          info: statsData.info || 0,
          high: statsData.high || 0,
          open: statsData.open || 0,
          inProgress: statsData.inProgress || 0,
          closed: statsData.closed || 0,
        });
      } else {
        console.error(
          "İstatistik verileri alınamadı:",
          statsRequest.statusText
        );
      }
    } catch (err) {
      console.error("İstatistikler getirilirken hata oluştu:", err);
    }
  }, [API_BASE_URL, ucerId]);

  // İş emri loglarını getirme fonksiyonu
  const fetchWorkOrderLogs = async (workOrderId) => {
    try {
      const request = await fetch(
        `${API_BASE_URL}/WorkOrder/logs/${workOrderId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (request.status === 200) {
        const logs = await request.json();
        return logs;
      }

      return [];
    } catch (err) {
      console.error("İş emri logları getirilirken hata oluştu:", err);
      return [];
    }
  };

  // Alarm notlarını güncelleme - optimized to update state locally
  const updateAlarmNotes = async (item, notes, assignedTo) => {
    try {
      const request = await fetch(`${API_BASE_URL}/Alarm/updateStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          ID: item.id,
          Notes: notes,
          AssignedTo: assignedTo,
          CompanyID: ucerId,
        }),
      });

      const response = await request.json();

      if (request.status === 200) {
        toast.success(`Alarm #${item.id} bilgileri güncellendi`);

        // Update the alarm in the list
        setAlarmList((prevAlarms) =>
          prevAlarms.map((alarm) =>
            alarm.id === item.id ? { ...alarm, notes, assignedTo } : alarm
          )
        );

        // Also update the selected alarm
        if (selectedAlarm && selectedAlarm.id === item.id) {
          setSelectedAlarm((prev) => ({
            ...prev,
            notes,
            assignedTo,
          }));
        }
      }
    } catch (err) {
      console.error("Alarm notları güncellenirken hata oluştu:", err);
      toast.error("Alarm bilgileri güncellenirken bir hata oluştu.");
    }
  };

  // Durum kodundan öncelik belirleme fonksiyonu
  const getPriorityFromStatusCode = (statusCode) => {
    // Durum kodlarına göre öncelik belirle
    if (statusCode >= 500) return "high"; // Kritik hatalar
    if (statusCode >= 400) return "medium"; // Uyarılar
    return "low"; // Bilgi mesajları
  };

  // Önceliğe göre badge rengi
  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "high":
        return "danger";
      case "medium":
        return "warning";
      case "low":
        return "info";
      default:
        return "secondary";
    }
  };

  // Geçen süreyi hesaplama
  const getTimeElapsed = (dateString) => {
    const now = new Date();
    const alarmDate = new Date(dateString);
    const diffMs = now - alarmDate;

    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 60) return `${minutes} dk`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} sa`;

    const days = Math.floor(hours / 24);
    return `${days} gün`;
  };

  // Added function to fetch work order by alarm ID
  const fetchWorkOrderByAlarmId = async (alarmId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/WorkOrder/getByRelatedEntity`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            entityType: "Alarm",
            entityId: alarmId,
            companyId: ucerId, // Şirket bazlı filtreleme için
          }),
        }
      );

      if (response.ok) {
        const workOrders = await response.json();
        if (workOrders && workOrders.length > 0) {
          return workOrders[0];
        }
      }

      return null;
    } catch (error) {
      console.error("İş emri detayları getirilirken hata:", error);
      return null;
    }
  };
  // Satır stilini belirle
  const getRowClassName = (item) => {
    let className = "";

    // Onaylanmamış ise
    if (item.confirm_ !== 1) {
      className += "unconfirmed-row ";
    }

    // Alarm durumuna göre stil
    if (item.alarmStatus) {
      className += `alarm-status-${item.alarmStatus.toLowerCase()} `;
    }

    return className.trim();
  };

  // Kart stilini belirle
  const getCardClassName = (item) => {
    let className = "";

    // Onaylanmamış ise
    if (item.confirm_ !== 1) {
      className += "unconfirmed-card ";
    }

    // Alarm durumuna göre stil
    if (item.alarmStatus) {
      className += `alarm-status-${item.alarmStatus.toLowerCase()} `;
    }

    return className.trim();
  };

  // AlarmStatusBadge bileşeni
  const AlarmStatusBadge = ({ status }) => {
    let variant, icon, text;

    switch (status) {
      case "Open":
        variant = "danger";
        icon = <BellFill className="me-1" />;
        text = "Açık";
        break;
      case "InProgress":
        variant = "warning";
        icon = <Clock className="me-1" />;
        text = "İlgileniliyor";
        break;
      case "Closed":
        variant = "success";
        icon = <CheckCircleFill className="me-1" />;
        text = "Çözüldü";
        break;
      default:
        variant = "secondary";
        icon = <BellFill className="me-1" />;
        text = status;
    }

    return (
      <Badge bg={variant}>
        {icon} {text}
      </Badge>
    );
  };

  // Tarih formatını düzenleme
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "Geçersiz Tarih";
    }

    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };


  //Delete alarm function
  const deleteAlarm = async (alarmId) => { 
    try {
      const request = await fetch(`${API_BASE_URL}/Alarm/${alarmId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });


        // Remove the deleted alarm from the list
        setAlarmList((prevAlarms) =>
          prevAlarms.filter((alarm) => alarm.id !== alarmId)
        );

        // Update statistics
        fetchAlarmStats();
      
    } catch (err) {
      console.error("Alarm silinirken hata oluştu:", err);
      toast.error("Alarm silinirken bir hata oluştu.");
    }
   }

  // Handle workflow events
  const handleWorkOrderCreated = async (workOrderId) => {
    if (alarmStatusChangeRequest) {
      // Now update the alarm status since we have a work order
      await updateAlarmStatus(
        alarmStatusChangeRequest.alarm,
        alarmStatusChangeRequest.targetStatus,
        `İş emri #${workOrderId} oluşturuldu.`
      );

      // Reset the request
      setAlarmStatusChangeRequest(null);
    }

    // Close the modal
    setShowWorkOrderCreationModal(false);

    // Refresh work orders if we're in detail view
    if (selectedAlarm) {
      // Fetch the newly created work order
      const workOrder = await fetchWorkOrderById(workOrderId);
      if (workOrder) {
        setSelectedAlarm((prev) => ({
          ...prev,
          workOrder,
        }));
      }
    }
  };

  // Handle closing notes submission
  const handleClosingNotesSubmit = async () => {
    if (alarmStatusChangeRequest) {
      // Check if there's a work order
      const workOrder = await fetchWorkOrderByAlarmId(
        alarmStatusChangeRequest.alarm.id
      );

      // If there's a work order, update it too
      if (workOrder) {
        await updateWorkOrderStatus(
          workOrder.WorkOrderID,
          "Completed",
          closingNotes
        );

        // Now update the alarm status
        await updateAlarmStatus(
          alarmStatusChangeRequest.alarm,
          alarmStatusChangeRequest.targetStatus,
          closingNotes
        );
      } else {
        // Just update the alarm status
        await updateAlarmStatus(
          alarmStatusChangeRequest.alarm,
          alarmStatusChangeRequest.targetStatus,
          closingNotes
        );
      }

      // Reset everything
      setAlarmStatusChangeRequest(null);
      setClosingNotes("");
      setShowClosingNotesModal(false);
    }
  };

  // Sıralama değiştirme fonksiyonu
  const handleSort = (field) => {
    setSorting((prev) => ({
      field,
      direction:
        prev.field === field && prev.direction === "desc" ? "asc" : "desc",
    }));
  };

  // Handle pagination changes
  const handlePageChange = (page) => {
    console.log(
      "Changing page to:",
      page,
      "Current page:",
      pagination.currentPage
    );
    if (page >= 1 && page <= pagination.totalPages) {
      setPagination((prev) => ({
        ...prev,
        currentPage: page,
      }));
    }
  };

  // Handle items per page change
  const handleItemsPerPageChange = (newSize) => {
    setPagination((prev) => ({
      ...prev,
      itemsPerPage: newSize,
      currentPage: 1, // Reset to first page
    }));
  };

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilter((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Modal kapama fonksiyonu
  const handleCloseModal = () => {
    setShowDetailModal(false);
    // Modal kapandıktan sonra seçili alarm state'ini temizle
    setTimeout(() => {
      setSelectedAlarm(null);
    }, 300);
  };

  // İstatistik verilerini güncelleyen fonksiyon için callback
  const handleLogsLoad = useCallback((logs) => {
    setSelectedAlarm((prev) => {
      if (!prev) return null;
      // Eğer mevcut loglar varsa ve yeni gelen loglar ile içerik olarak aynıysa güncelleme yapma.
      if (prev.logs && JSON.stringify(prev.logs) === JSON.stringify(logs)) {
        return prev;
      }
      return { ...prev, logs };
    });
  }, []);

  const handleWorkOrderLoad = useCallback((workOrder) => {
    setSelectedAlarm((prev) => {
      if (!prev) return null;
      return { ...prev, workOrder };
    });
  }, []);

  // LogsTabPane bileşeni - React.memo ile wrap edilerek gereksiz render'ları önleniyor
  const LogsTabPane = React.memo(({ alarmId, logs = [], onLogsLoad }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchAttempted, setFetchAttempted] = useState(false);
    const loadedLogsRef = useRef(logs || []);

    // İlk render'da logları yükle
    useEffect(() => {
      let isMounted = true;

      if (!alarmId) return;

      // If we already have logs, don't fetch again
      if (logs && logs.length > 0) {
        setFetchAttempted(true);
        return;
      }

      // If we've already tried to fetch logs, don't try again
      if (fetchAttempted) {
        return;
      }

      const fetchData = async () => {
        setIsLoading(true);
        try {
          const result = await fetchAlarmLogs(alarmId);
          if (isMounted) {
            loadedLogsRef.current = result;
            if (typeof onLogsLoad === "function") {
              onLogsLoad(result);
            }
            setFetchAttempted(true);
          }
        } catch (error) {
          console.error("Log kayıtları yüklenirken hata:", error);
          if (isMounted) {
            setFetchAttempted(true);
          }
        } finally {
          if (isMounted) {
            setIsLoading(false);
          }
        }
      };

      fetchData();

      // Temizleme fonksiyonu
      return () => {
        isMounted = false;
      };
    }, [alarmId, logs, onLogsLoad, fetchAttempted]);

    // Yenile butonu için
    const handleRefresh = () => {
      if (!alarmId) return;

      setIsLoading(true);
      fetchAlarmLogs(alarmId)
        .then((result) => {
          loadedLogsRef.current = result;
          if (typeof onLogsLoad === "function") {
            onLogsLoad(result);
          }
        })
        .catch((error) => {
          console.error("Log kayıtları yüklenirken hata:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const displayLogs = logs && logs.length > 0 ? logs : loadedLogsRef.current;

    // Format log entry text for better display
    const formatLogEntry = (log) => {
      if (!log.Description) return "-";

      // Create clickable links if there are work order references
      const workOrderRegex = /İş emri #(\d+)/g;
      return log.Description.replace(
        workOrderRegex,
        '<a href="javascript:void(0)" class="text-primary">İş emri #$1</a>'
      );
    };

    return (
      <div>
        {isLoading ? (
          <div className="text-center p-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Log kayıtları yükleniyor...</p>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleRefresh}
              >
                <ArrowClockwise className="me-1" /> Yenile
              </Button>
            </div>

            {displayLogs && displayLogs.length > 0 ? (
              <Table bordered hover size="sm">
                <thead>
                  <tr>
                    <th style={{ width: "180px" }}>Tarih</th>
                    <th>İşlem</th>
                    <th style={{ width: "100px" }}>Kullanıcı</th>
                    <th>Açıklama</th>
                  </tr>
                </thead>
                <tbody>
                  {displayLogs.map((log, index) => (
                    <tr key={log.LogID || `log-${index}`}>
                      <td>{formatDate(log.actionDate)}</td>
                      <td>{log.action}</td>
                      <td>{log.userID || "Sistem"}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: formatLogEntry(log),
                        }}
                      ></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Alert variant="info">
                <Info className="me-2" />
                Bu alarm için log kaydı bulunamadı.
              </Alert>
            )}
          </>
        )}
      </div>
    );
  });
  // WorkOrder bileşenleri - React.memo ile sarılmış
  const WorkOrderLogs = React.memo(({ workOrderId }) => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      let isMounted = true;

      if (!workOrderId) return;

      const fetchData = async () => {
        setIsLoading(true);
        try {
          const result = await fetchWorkOrderLogs(workOrderId);
          if (isMounted) {
            setLogs(result);
          }
        } catch (error) {
          console.error("İş emri log kayıtları getirilirken hata:", error);
        } finally {
          if (isMounted) {
            setIsLoading(false);
          }
        }
      };

      fetchData();

      return () => {
        isMounted = false;
      };
    }, [workOrderId]);

    // Yenile fonksiyonu
    const handleRefresh = () => {
      if (!workOrderId) return;

      setIsLoading(true);
      fetchWorkOrderLogs(workOrderId)
        .then((result) => {
          setLogs(result);
        })
        .catch((error) => {
          console.error("İş emri log kayıtları getirilirken hata:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    return (
      <Card className="mt-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">İş Emri Geçmişi</h6>
          <Button variant="outline-secondary" size="sm" onClick={handleRefresh}>
            <ArrowClockwise /> Yenile
          </Button>
        </Card.Header>
        <Card.Body>
          {isLoading ? (
            <div className="text-center p-3">
              <Spinner animation="border" size="sm" />
              <p className="mb-0 mt-2">Yükleniyor...</p>
            </div>
          ) : logs.length === 0 ? (
            <Alert variant="info">Log kaydı bulunamadı.</Alert>
          ) : (
            <Table responsive bordered hover size="sm">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>İşlem</th>
                  <th>Eski Durum</th>
                  <th>Yeni Durum</th>
                  <th>Kullanıcı</th>
                  <th>Açıklama</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.LogID}>
                    <td>{formatDate(log.ActionDate)}</td>
                    <td>{log.Action}</td>
                    <td>{log.PreviousStatus || "-"}</td>
                    <td>{log.NewStatus || "-"}</td>
                    <td>{log.UserID || "Sistem"}</td>
                    <td>{log.Description || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    );
  });

  const WorkOrderDetails = React.memo(({ workOrder, onRefresh }) => {
    if (!workOrder)
      return <Alert variant="info">Bu alarm için iş emri bulunamadı.</Alert>;

    // İş emri durum renklerini tanımla
    const getStatusBadgeVariant = (status) => {
      switch (status) {
        case "Created":
          return "secondary";
        case "Assigned":
          return "info";
        case "InProgress":
          return "warning";
        case "OnHold":
          return "danger";
        case "Completed":
          return "success";
        case "Cancelled":
          return "dark";
        default:
          return "secondary";
      }
    };

    // İş emri durum metinlerini tanımla
    const getStatusText = (status) => {
      switch (status) {
        case "Created":
          return "Oluşturuldu";
        case "Assigned":
          return "Atandı";
        case "InProgress":
          return "Devam Ediyor";
        case "OnHold":
          return "Beklemede";
        case "Completed":
          return "Tamamlandı";
        case "Cancelled":
          return "İptal Edildi";
        default:
          return status;
      }
    };

    // Öncelik badge bileşeni
    const PriorityBadge = ({ priority }) => {
      const getVariant = () => {
        switch (priority?.toLowerCase()) {
          case "low":
            return "success";
          case "medium":
            return "warning";
          case "high":
            return "danger";
          case "critical":
            return "dark";
          default:
            return "secondary";
        }
      };

      const getText = () => {
        switch (priority?.toLowerCase()) {
          case "low":
            return "Düşük";
          case "medium":
            return "Orta";
          case "high":
            return "Yüksek";
          case "critical":
            return "Kritik";
          default:
            return priority || "Belirsiz";
        }
      };

      return <Badge bg={getVariant()}>{getText()}</Badge>;
    };

    const handleStatusChange = async (newStatus) => {
      const result = await updateWorkOrderStatus(
        workOrder.WorkOrderID,
        newStatus
      );
      if (result && typeof onRefresh === "function") {
        onRefresh();
      }
    };

    return (
      <Card className="mb-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div>
            <strong>İş Emri # {workOrder.workOrderID}</strong>
          </div>
          <Badge bg={getStatusBadgeVariant(workOrder.workOrderStatus)}>
            {getStatusText(workOrder.workOrderStatus)}
          </Badge>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <p>
                <strong>Başlık:</strong> {workOrder.title}
              </p>
              <p>
                <strong>Öncelik:</strong>{" "}
                <PriorityBadge priority={workOrder.priority} />
              </p>
              <p>
                <strong>Oluşturulma Tarihi:</strong>{" "}
                {formatDate(workOrder.creationDate)}
              </p>
              <p>
                <strong>Son Tarih:</strong>{" "}
                {workOrder.dueDate
                  ? formatDate(workOrder.dueDate)
                  : "Belirtilmemiş"}
              </p>
            </Col>
            <Col md={6}>
              <p>
                <strong>Atanan Kişi:</strong>{" "}
                {workOrder.assignedUserID || "Atanmamış"}
              </p>
              <p>
                <strong>Konum:</strong> {workOrder.location || "Belirtilmemiş"}
              </p>
              <p>
                <strong>Ekipman:</strong>{" "}
                {workOrder.equipment || "Belirtilmemiş"}
              </p>
              <p>
                <strong>Tamamlanma Tarihi:</strong>{" "}
                {workOrder.completionDate
                  ? formatDate(workOrder.completionDate)
                  : "Tamamlanmadı"}
              </p>
            </Col>
          </Row>

          <hr />

          <h6>Açıklama</h6>
          <p>{workOrder.description || "Açıklama bulunmuyor."}</p>

          <div className="d-flex justify-content-end mt-3">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={onRefresh}
              className="me-2"
            >
              <ArrowClockwise className="me-1" /> Yenile
            </Button>

            <DropdownButton
              variant="primary"
              size="sm"
              title="Durum Değiştir"
              disabled={
                workOrder.workOrderStatus === "Completed" ||
                workOrder.workOrderStatus === "Cancelled"
              }
            >
              <Dropdown.Item onClick={() => handleStatusChange("Assigned")}>
                <Person className="me-1" /> Atandı
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleStatusChange("InProgress")}>
                <Clock className="me-1" /> Devam Ediyor
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleStatusChange("OnHold")}>
                <Calendar2Week className="me-1" /> Beklemede
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleStatusChange("Completed")}>
                <CheckCircleFill className="me-1" /> Tamamlandı
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => handleStatusChange("Cancelled")}>
                <XCircleFill className="me-1" /> İptal Et
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </Card.Body>
      </Card>
    );
  });

  // Improved WorkOrdersTabPane
  const WorkOrdersTabPane = React.memo(
    ({ alarmId, workOrder, onWorkOrderLoad, onCreateWorkOrder }) => {
      const [isLoading, setIsLoading] = useState(false);
      const [showCreateForm, setShowCreateForm] = useState(false);
      const [hasError, setHasError] = useState(false);
      const [fetchAttempted, setFetchAttempted] = useState(false);
      const loadedWorkOrderRef = useRef(workOrder);

      // Function to fetch work order by ID - define here if it's not available in scope
      const fetchWorkOrderById = async (workOrderId) => {
        try {
          const response = await fetch(
            `${API_BASE_URL}/WorkOrder/${workOrderId}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
              },
            }
          );

          if (response.ok) {
            return await response.json();
          }

          return null;
        } catch (error) {
          console.error("Error fetching work order details:", error);
          return null;
        }
      };

      // Make sure to use either the prop workOrder or the locally loaded one
      const displayWorkOrder = workOrder || loadedWorkOrderRef.current;

      // Simplified refresh function with better error handling
      const handleRefresh = useCallback(() => {
        if (!alarmId) return;

        setIsLoading(true);
        setHasError(false);

        fetch(`${API_BASE_URL}/WorkOrder/getByRelatedEntity`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            entityType: "Alarm",
            entityId: alarmId,
            companyId: ucerId,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Failed to load work orders (HTTP ${response.status})`
              );
            }
            return response.json();
          })
          .then((workOrders) => {
            if (
              workOrders &&
              Array.isArray(workOrders) &&
              workOrders.length > 0
            ) {
              loadedWorkOrderRef.current = workOrders[0];
              if (typeof onWorkOrderLoad === "function") {
                onWorkOrderLoad(workOrders[0]);
              }
            } else {
              loadedWorkOrderRef.current = null;
              if (typeof onWorkOrderLoad === "function") {
                onWorkOrderLoad(null);
              }
            }
            setFetchAttempted(true);
          })
          .catch((error) => {
            console.error("Error fetching work order details:", error);
            setHasError(true);
            setFetchAttempted(true);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }, [alarmId, onWorkOrderLoad]);

      // Effect to load work order when alarmId changes
      useEffect(() => {
        if (alarmId) {
          setFetchAttempted(false);
          handleRefresh();
        }
      }, [alarmId, handleRefresh]);

      // Handle work order creation
      // Function to update alarm status after work order is created
      const updateAlarmAfterWorkOrder = async (alarmId, workOrderId) => {
        try {
          // Call the external updateAlarmStatus function - assuming it's available in the component scope
          // If this function isn't available in scope, you'll need to implement it here or pass it as a prop
          await fetch(`${API_BASE_URL}/Alarm/updateStatus`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              AlarmId: alarmId,
              NewStatus: "InProgress", // Set status to "In Progress"
              UserId: 0, // Default value
              Description: `Work order #${workOrderId} created.`,
            }),
          });
        } catch (error) {
          console.error("Error updating alarm status:", error);
        }
      };

      const handleWorkOrderCreated = async (workOrderId) => {
        setShowCreateForm(false);
        setIsLoading(true);

        try {
          // Get work order details
          const workOrder = await fetchWorkOrderById(workOrderId);

          if (workOrder) {
            // Update local reference
            loadedWorkOrderRef.current = workOrder;

            // Call callback to update parent component
            if (typeof onWorkOrderLoad === "function") {
              onWorkOrderLoad(workOrder);
            }

            // Update alarm status if needed
            if (alarmId) {
              await updateAlarmAfterWorkOrder(alarmId, workOrderId);
            }
          }

          // Call creation callback
          if (typeof onCreateWorkOrder === "function") {
            onCreateWorkOrder(workOrderId);
          }
        } catch (error) {
          console.error("Error processing work order:", error);
          toast.warning(
            "Work order created but failed to load details. Try refreshing."
          );
        } finally {
          setIsLoading(false);
          setFetchAttempted(true);
        }
      };

      return (
        <div>
          {isLoading ? (
            <div className="text-center p-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Loading work order information...</p>
            </div>
          ) : hasError ? (
            <Alert variant="danger">
              <Alert.Heading>Connection Error</Alert.Heading>
              <p>
                There was a problem loading work order information. Please check
                API connection.
              </p>
              <hr />
              <div className="d-flex justify-content-end">
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    setHasError(false);
                    setFetchAttempted(false);
                    handleRefresh();
                  }}
                >
                  <ArrowClockwise className="me-1" /> Retry
                </Button>
              </div>
            </Alert>
          ) : (
            <>
              {!displayWorkOrder && !showCreateForm && fetchAttempted ? (
                <div className="text-center p-4">
                  <p>No work order has been created for this alarm yet.</p>
                  <Button
                    style={{ pointerEvents: alarm_yazma ? "all" : "none", opacity: alarm_yazma ? "1" : "0.75" }}
                    variant="primary"
                    onClick={() => {
                      if (alarm_yazma) setShowCreateForm(true)
                    }
                    }
                  >
                    <Tools className="me-1" /> Create Work Order
                  </Button>
                </div>
              ) : showCreateForm ? (
                <CreateWorkOrderForm
                  alarmId={alarmId}
                  onWorkOrderCreated={handleWorkOrderCreated}
                  onCancel={() => setShowCreateForm(false)}
                />
              ) : displayWorkOrder ? (
                <>
                  <WorkOrderDetails
                    workOrder={displayWorkOrder}
                    onRefresh={handleRefresh}
                  />

                  <WorkOrderLogs workOrderId={displayWorkOrder.WorkOrderID} />
                </>
              ) : null}
            </>
          )}
        </div>
      );
    }
  );
  // Modal için tab bileşenleri
  const AlarmDetailTabs = React.memo(
    ({
      alarm,
      onAlarmStatusChange,
      onLogsLoad,
      onWorkOrderLoad,
      onCreateWorkOrder,
    }) => {
      return (
        <Tabs defaultActiveKey="alarm" className="mb-3">
          <Tab eventKey="alarm" title="Alarm Detayları">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Atanacak Kişi</Form.Label>
                <Form.Control
                  type="text"
                  disabled={alarm_yazma ? false : true}
                  defaultValue={alarm.assignedTo || ""}
                  id="assignedToInput"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Notlar</Form.Label>
                <Form.Control
                  as="textarea"
                  disabled={alarm_yazma ? false : true}
                  rows={3}
                  defaultValue={alarm.notes || ""}
                  id="notesInput"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Alarm Durumu</Form.Label>
                <div className="d-flex gap-2">
                  <Button
                    style={{ pointerEvents: alarm_yazma ? "all" : "none", opacity: alarm_yazma ? "1" : "0.75" }}
                    variant={
                      alarm.alarmStatus === "Open" ? "danger" : "outline-danger"
                    }
                    onClick={() => {
                      if (alarm_yazma) {
                        typeof onAlarmStatusChange === "function" &&
                          onAlarmStatusChange("Open")
                      }

                    }

                    }
                  >
                    <BellFill className="me-1" /> Açık
                  </Button>
                  <Button
                    style={{ pointerEvents: alarm_yazma ? "all" : "none", opacity: alarm_yazma ? "1" : "0.75" }}

                    variant={
                      alarm.alarmStatus === "InProgress"
                        ? "warning"
                        : "outline-warning"
                    }
                    onClick={() => {
                      if (alarm_yazma) {
                        typeof onAlarmStatusChange === "function" &&
                          onAlarmStatusChange("InProgress")
                      }

                    }}
                  >
                    <Clock className="me-1" /> İlgileniliyor
                  </Button>
                  <Button
                    style={{ pointerEvents: alarm_yazma ? "all" : "none", opacity: alarm_yazma ? "1" : "0.75" }}

                    variant={
                      alarm.alarmStatus === "Closed"
                        ? "success"
                        : "outline-success"
                    }
                    onClick={() => {
                      if (alarm_yazma) {
                        typeof onAlarmStatusChange === "function" &&
                          onAlarmStatusChange("Closed")
                      }
                    }

                    }
                  >
                    <CheckCircleFill className="me-1" /> Çözüldü
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </Tab>
          <Tab eventKey="logs" title="Alarm Geçmişi">
            <LogsTabPane
              alarmId={alarm.id}
              logs={alarm.logs || []}
              onLogsLoad={onLogsLoad}
            />
          </Tab>

          <Tab eventKey="workOrder" title="İş Emri">
            <WorkOrdersTabPane
              alarmId={alarm.id}
              workOrder={alarm.workOrder}
              onWorkOrderLoad={onWorkOrderLoad}
              onCreateWorkOrder={onCreateWorkOrder}
            />
          </Tab>
        </Tabs>
      );
    }
  );

  // CSV çıktısı için veri hazırlama
  const csvData = alarmList.map((alarm) => ({
    ID: alarm.id,
    Mesaj: alarm.message,
    "Etiket Adı": alarm.tagName,
    "Etiket ID": alarm.tagId,
    Tarih: formatDate(alarm.date),
    "Durum Kodu": alarm.statusCode,
    Öncelik:
      alarm.priority === "high"
        ? "Yüksek"
        : alarm.priority === "medium"
          ? "Orta"
          : "Düşük",
    "Alarm Durumu":
      alarm.alarmStatus === "Open"
        ? "Açık"
        : alarm.alarmStatus === "InProgress"
          ? "İlgileniliyor"
          : alarm.alarmStatus === "Closed"
            ? "Çözüldü"
            : alarm.alarmStatus,
    "Onay Durumu": alarm.confirm_ === 1 ? "Onaylandı" : "Onaylanmadı",
    "Atanan Kişi": alarm.assignedTo || "Atanmadı",
    Notlar: alarm.notes || "",
  }));

  // Alarm detay modalını göster
  const showDetails = (alarm) => {
    // Önce temel alarm bilgisiyle modalı aç
    setSelectedAlarm(alarm);
    setShowDetailModal(true);
    setDetailsLoading(true);

    // Ardından detay bilgilerini arka planda yükle
    Promise.all([fetchAlarmLogs(alarm.id), fetchWorkOrderByAlarmId(alarm.id)])
      .then(([logs, workOrder]) => {
        setSelectedAlarm((prev) => {
          if (!prev || prev.id !== alarm.id) return prev;
          return { ...prev, logs, workOrder };
        });
      })
      .catch((error) => {
        console.error("Alarm detayları yüklenirken hata:", error);
        toast.error("Alarm detayları yüklenirken bir hata oluştu");
      })
      .finally(() => {
        setDetailsLoading(false);
      });
  };
  return (
    <div className="enhanced-alarm-container">
      {/* Üst İstatistik Kartları */}
      <Row className="top-alarm-cards">
        <Col style={{
          width: "30%"
        }} md={4}>
          <Card style={{ borderColor: "black" }} className="stats-card total">
            <Card.Body>
              <h5>Seviye 1</h5>
              <h2>{stats.high}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col style={{
          width: "30%"
        }} md={4}>
          <Card style={{ borderColor: "black", backgroundColor: "rgb(237,188,69)" }} className="stats-card warning">
            <Card.Body>
              <h5>Seviye 2</h5>
              <h2>{stats.warning}</h2>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{
          width: "30%"
        }} md={4}>
          <Card style={{
            borderColor: "black", backgroundColor: "rgb(223,36,36)", color: "black"
          }} className="stats-card critical">
            <Card.Body>
              <h5>Seviye 3</h5>
              <h2>{stats.critical}</h2>
            </Card.Body>
          </Card>
        </Col>

      </Row>

      {/* Alarm durumları için yeni row */}
      <Row className="second-alarm-cards">
        <Col style={{
          width: "18.5%"
        }} md={3}>
          <Card style={{ backgroundColor: "rgb(237,188,69)", border: "1px solid black", color: "black" }} className="stats-card total">
            <Card.Body>
              <h5>Toplam Alarmlar</h5>
              <h2>{stats.total}</h2>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{
          width: "18.5%"
        }} md={3}>
          <Card style={{ backgroundColor: "rgb(237,188,69)", border: "1px solid black", color: "black" }} className="stats-card">
            <Card.Body>
              <h5>Açık Alarmlar</h5>
              <h2>{stats.open}</h2>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{
          width: "18.5%"
        }} md={3}>
          <Card style={{ backgroundColor: "rgb(237,188,69)", border: "1px solid black", color: "black" }} className="stats-card unconfirmed">
            <Card.Body>
              <h5>Onaylanmamış</h5>
              <h2>{stats.unconfirmed}</h2>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{
          width: "18.5%"
        }} md={3}>
          <Card style={{ backgroundColor: "rgb(237,188,69)", border: "1px solid black", color: "black" }} className="stats-card">
            <Card.Body>
              <h5>İlgilenilen Alarmlar</h5>
              <h2>{stats.inProgress}</h2>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{
          width: "18.5%"
        }} md={3}>
          <Card style={{ backgroundColor: "rgb(237,188,69)", border: "1px solid black", color: "black" }} className="stats-card">
            <Card.Body>
              <h5>Çözülen Alarmlar</h5>
              <h2>{stats.closed}</h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Filtre ve Araç Çubuğu */}
      <Card className="filter-body">
        <Card.Body>
          <Row className="filter-table-top-row">
            <Col md={3} className="filter-input">
              <InputGroup className="mb-3 ">
                <InputGroup.Text>
                  <FilterCircle />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Ara..."
                  value={filter.search}
                  onChange={(e) => handleFilterChange("search", e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={3} className="durum-oncelik-alarm">
              <InputGroup className="mb-3 ">
                <DropdownButton
                  variant="outline-secondary"
                  title={`Durum: ${filter.status === "all"
                    ? "Tümü"
                    : filter.status === "confirmed"
                      ? "Onaylanmış"
                      : "Onaylanmamış"
                    }`}
                >
                  <Dropdown.Item
                    onClick={() => handleFilterChange("status", "all")}
                  >
                    Tümü
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("status", "confirmed")}
                  >
                    Onaylanmış
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("status", "unconfirmed")}
                  >
                    Onaylanmamış
                  </Dropdown.Item>
                </DropdownButton>
              </InputGroup>
            </Col>
            <Col md={3} className="durum-oncelik-alarm">
              <InputGroup className="mb-3 ">
                <DropdownButton
                  variant="outline-secondary"
                  title={`Öncelik: ${filter.priority === "all"
                    ? "Tümü"
                    : filter.priority === "high"
                      ? "Yüksek"
                      : filter.priority === "medium"
                        ? "Orta"
                        : "Düşük"
                    }`}
                >
                  <Dropdown.Item
                    onClick={() => handleFilterChange("priority", "all")}
                  >
                    Tümü
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("priority", "high")}
                  >
                    Yüksek
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("priority", "medium")}
                  >
                    Orta
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("priority", "low")}
                  >
                    Düşük
                  </Dropdown.Item>
                </DropdownButton>
              </InputGroup>
            </Col>
            <Col md={3} className="durum-oncelik-alarm durum-oncelik-son">
              <InputGroup className="mb-3">
                <DropdownButton
                  variant="outline-secondary"
                  title={`Alarm Durumu: ${filter.alarmStatus === "all"
                    ? "Tümü"
                    : filter.alarmStatus === "Open"
                      ? "Açık"
                      : filter.alarmStatus === "InProgress"
                        ? "İlgileniliyor"
                        : filter.alarmStatus === "Closed"
                          ? "Çözüldü"
                          : filter.alarmStatus
                    }`}
                >
                  <Dropdown.Item
                    onClick={() => handleFilterChange("alarmStatus", "all")}
                  >
                    Tümü
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("alarmStatus", "Open")}
                  >
                    Açık
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handleFilterChange("alarmStatus", "InProgress")
                    }
                  >
                    İlgileniliyor
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterChange("alarmStatus", "Closed")}
                  >
                    Çözüldü
                  </Dropdown.Item>
                </DropdownButton>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mt-2 date-container">
            <Col md={6} className="start-date-container">
              <Form.Group className="mb-3">
                <Form.Label>Başlangıç Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  value={filter.dateRange.start || ""}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      dateRange: { ...prev.dateRange, start: e.target.value },
                    }))
                  }
                />
              </Form.Group>
            </Col>
            <Col md={6} className="end-date-container">
              <Form.Group className="mb-3">
                <Form.Label>Bitiş Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  value={filter.dateRange.end || ""}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      dateRange: { ...prev.dateRange, end: e.target.value },
                    }))
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div className="yenile-csv-pdf d-flex justify-content-end">
                <Button
                  className="yenile-button"
                  onClick={() => fetchAlarms()}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <ArrowClockwise />
                  )}
                  Yenile
                </Button>
                <CSVLink
                  style={{ pointerEvents: alarm_yazma ? "all" : "none" }}
                  data={csvData}
                  filename={"alarm-raporu.csv"}
                  className="btn btn-outline-success me-2 csv-button"
                >
                  <FileEarmarkExcel /> CSV
                </CSVLink>

                {/* PDF butonunu değiştirdik - PDF oluşturma sürecini başlatmak için */}
                <Button
                  variant="outline-danger"
                  className="pdf-button"
                  onClick={() => {
                    if (alarm_yazma) setShowPdfLink(true)
                  }
                  }
                >
                  <FileEarmarkPdf /> PDF
                </Button>

                {/* Sadece PDF butonu tıklandığında link göster */}
                {showPdfLink && (
                  <div className="mt-3">
                    <PDFDownloadLink
                      document={<AlarmPdfDocument alarms={alarmList} />}
                      fileName="alarm-raporu.pdf"
                      className="btn btn-danger"
                    >
                      {({ loading, error }) =>
                        loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : error ? (
                          "PDF oluşturulamadı"
                        ) : (
                          "PDF'i İndir"
                        )
                      }
                    </PDFDownloadLink>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Loading Indicator */}
      {initialLoading ? (
        <div className="alarm-loading text-center p-5">
          <Spinner animation="border" variant="primary" />
          <p className="alarm-loading-text mt-3">Alarmlar yükleniyor...</p>
        </div>
      ) : (
        <Card className="alarm-card">
          <Card.Body className="alarm-card-body">
            {/* Alarm List Table */}
            <Table responsive striped hover className="alarm-table">
              <thead className="alarm-thead">
                <tr className="alarm-tr-header">
                  <th
                    onClick={() => handleSort("id")}
                    style={{ cursor: "pointer" }}
                    className="alarm-th alarm-th-id"
                  >
                    ID{" "}
                    {sorting.field === "id" &&
                      (sorting.direction === "asc" ? (
                        <SortUp className="alarm-sort-icon" />
                      ) : (
                        <SortDown className="alarm-sort-icon" />
                      ))}
                  </th>
                  <th
                    onClick={() => handleSort("message")}
                    style={{ cursor: "pointer" }}
                    className="alarm-th alarm-th-message"
                  >
                    Mesaj{" "}
                    {sorting.field === "message" &&
                      (sorting.direction === "asc" ? (
                        <SortUp className="alarm-sort-icon" />
                      ) : (
                        <SortDown className="alarm-sort-icon" />
                      ))}
                  </th>
                  <th
                    onClick={() => handleSort("tagName")}
                    style={{ cursor: "pointer" }}
                    className="alarm-th alarm-th-tag"
                  >
                    Etiket{" "}
                    {sorting.field === "tagName" &&
                      (sorting.direction === "asc" ? (
                        <SortUp className="alarm-sort-icon" />
                      ) : (
                        <SortDown className="alarm-sort-icon" />
                      ))}
                  </th>
                  <th
                    onClick={() => handleSort("date")}
                    style={{ cursor: "pointer" }}
                    className="alarm-th alarm-th-date"
                  >
                    Tarih{" "}
                    {sorting.field === "date" &&
                      (sorting.direction === "asc" ? (
                        <SortUp className="alarm-sort-icon" />
                      ) : (
                        <SortDown className="alarm-sort-icon" />
                      ))}
                  </th>
                  <th className="alarm-th alarm-th-priority">Öncelik</th>
                  <th className="alarm-th alarm-th-status">Durum</th>
                  <th className="alarm-th alarm-th-actions">İşlemler</th>
                </tr>
              </thead>
              <tbody className="alarm-tbody">
                {loading ? (
                  <tr className="alarm-tr-loading">
                    <td colSpan="7" className="alarm-td-loading text-center">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="alarm-spinner-small"
                      />{" "}
                      Yükleniyor...
                    </td>
                  </tr>
                ) : alarmList.length === 0 ? (
                  <tr className="alarm-tr-empty">
                    <td colSpan="7" className="alarm-td-empty text-center">
                      Hiç alarm bulunamadı.
                    </td>
                  </tr>
                ) : (
                  alarmList.map((item) => {
                    console.log(item)
                    return <tr
                      key={item.id}
                      className={`alarm-tr ${getRowClassName(
                        item
                      )} alarm-tr-item`}
                      onClick={() => showDetails(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="alarm-td alarm-td-id">#{item.id}</td>
                      <td className="alarm-td alarm-td-message">
                        {item.message}
                      </td>
                      <td className="alarm-td alarm-td-tag">{item.tagName}</td>
                      <td className="alarm-td alarm-td-date">
                        {formatDate(item.date)}
                        <br />
                        <small className="alarm-time-elapsed text-muted">
                          {item.timeElapsed} önce
                        </small>
                      </td>
                      <td className="alarm-td alarm-td-priority">
                        <Badge
                          bg={
                            item.priority === "high"
                              ? "danger"
                              : item.priority === "medium"
                                ? "warning"
                                : "info"
                          }
                          className={`alarm-badge alarm-badge-${item.priority}`}
                        >
                          {item.priority === "high"
                            ? "Yüksek"
                            : item.priority === "medium"
                              ? "Orta"
                              : "Düşük"}
                        </Badge>
                      </td>
                      <td className="alarm-td alarm-td-status">
                        <Badge
                          bg={
                            item.alarmStatus === "Open"
                              ? "danger"
                              : item.alarmStatus === "InProgress"
                                ? "warning"
                                : "success"
                          }
                          className={`alarm-status-badge alarm-status-${item.alarmStatus || "Open"
                            }`}
                        >
                          {item.alarmStatus === "Open"
                            ? "Açık"
                            : item.alarmStatus === "InProgress"
                              ? "İlgileniliyor"
                              : "Çözüldü"}
                        </Badge>
                      </td>
                      <td className="alarm-td alarm-td-actions">
                        <ButtonGroup size="sm" className="alarm-btn-group">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip className="alarm-tooltip">
                                {item.confirm_ !== 1
                                  ? "Onayla"
                                  : "Onayı Kaldır"}
                              </Tooltip>
                            }
                          >
                            <Button
                              disabled={alarm_yazma ? (item.alarmStatus !== "Open" && item.alarmStatus !== "InProgress") ? true : false : true}
                              variant={
                                item.confirm_ !== 1
                                  ? "outline-success"
                                  : "outline-warning"
                              }
                              className={`alarm-btn alarm-btn-confirm ${item.confirm_ !== 1
                                ? "alarm-btn-confirm-yes"
                                : "alarm-btn-confirm-no"
                                }`}
                              onClick={(e) => {
                                e.stopPropagation();

                                if (alarm_yazma) {
                                  updateAlarm(item, item.confirm_ !== 1);
                                }

                              }}
                            >
                              {item.confirm_ !== 1 ? (
                                <CheckCircleFill className="alarm-icon-check" />
                              ) : (
                                <XCircleFill className="alarm-icon-x" />
                              )}
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip className="alarm-tooltip">
                                Detaylar
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-primary"
                              className="alarm-btn alarm-btn-details"
                              onClick={(e) => {
                                e.stopPropagation();
                                showDetails(item);
                              }}
                            >
                              <Info className="alarm-icon-info" />
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip className="alarm-tooltip">
                                Sil
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-danger"
                              style={{pointerEvents:alarm_silme?"all":"none",opacity:alarm_silme?"1":"0.75"}}
                              className="alarm-btn alarm-btn-delete"
                              disabled={alarm_silme?false:true}
                              onClick={(e) => {
                                if (alarm_silme) {
                                  e.stopPropagation();
                                  deleteAlarm(item.id);
                                }

                              }}
                            >
                              <Trash className="alarm-icon-trash" />
                            </Button>
                          </OverlayTrigger>
                        </ButtonGroup>
                      </td>
                    </tr>
                  })
                )}
              </tbody>
            </Table>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-3 alarm-pagination-container">
              <div className="alarm-items-per-page">
                <DropdownButton
                  variant="outline-secondary"
                  title={`${pagination.itemsPerPage} kayıt/sayfa`}
                  size="sm"
                  className="alarm-dropdown"
                >
                  <Dropdown.Item
                    onClick={() => handleItemsPerPageChange(10)}
                    className="alarm-dropdown-item"
                  >
                    10 kayıt/sayfa
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleItemsPerPageChange(25)}
                    className="alarm-dropdown-item"
                  >
                    25 kayıt/sayfa
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleItemsPerPageChange(50)}
                    className="alarm-dropdown-item"
                  >
                    50 kayıt/sayfa
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleItemsPerPageChange(100)}
                    className="alarm-dropdown-item"
                  >
                    100 kayıt/sayfa
                  </Dropdown.Item>
                </DropdownButton>
              </div>

              <Pagination size="sm" className="alarm-pagination">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={pagination.currentPage <= 1}
                  className="alarm-pagination-first"
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(pagination.currentPage - 1)}
                  disabled={pagination.currentPage <= 1}
                  className="alarm-pagination-prev"
                />

                {/* Page number indicators */}
                {[...Array(Math.min(5, pagination.totalPages))].map(
                  (_, index) => {
                    // Calculate page numbers to show around the current page
                    let pageNum;
                    if (pagination.totalPages <= 5) {
                      pageNum = index + 1;
                    } else if (pagination.currentPage <= 3) {
                      pageNum = index + 1;
                    } else if (
                      pagination.currentPage >=
                      pagination.totalPages - 2
                    ) {
                      pageNum = pagination.totalPages - 4 + index;
                    } else {
                      pageNum = pagination.currentPage - 2 + index;
                    }

                    // Only show if pageNum is valid
                    if (pageNum > 0 && pageNum <= pagination.totalPages) {
                      return (
                        <Pagination.Item
                          key={pageNum}
                          active={pageNum === pagination.currentPage}
                          onClick={() => handlePageChange(pageNum)}
                          className={`alarm-pagination-item ${pageNum === pagination.currentPage
                            ? "alarm-pagination-item-active"
                            : ""
                            }`}
                        >
                          {pageNum}
                        </Pagination.Item>
                      );
                    }
                    return null;
                  }
                )}

                <Pagination.Next
                  onClick={() => handlePageChange(pagination.currentPage + 1)}
                  disabled={pagination.currentPage >= pagination.totalPages}
                  className="alarm-pagination-next"
                />
                <Pagination.Last
                  onClick={() => handlePageChange(pagination.totalPages)}
                  disabled={pagination.currentPage >= pagination.totalPages}
                  className="alarm-pagination-last"
                />
              </Pagination>

              <div className="text-muted small alarm-pagination-info">
                {pagination.totalItems > 0 ? (
                  <>
                    Toplam {pagination.totalItems} kayıt içinden{" "}
                    {(pagination.currentPage - 1) * pagination.itemsPerPage + 1}
                    {" - "}
                    {Math.min(
                      pagination.currentPage * pagination.itemsPerPage,
                      pagination.totalItems
                    )}{" "}
                    arası gösteriliyor
                  </>
                ) : (
                  "Kayıt bulunamadı"
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Alternative Card View for Mobile */}
      {/* This could be conditionally displayed based on screen size or a toggle button */}
      <div className="d-md-none mt-4">
        {alarmList.map((item) => (
          <Card
            key={item.id}
            className={`mb-3 ${getCardClassName(item)}`}
            onClick={() => showDetails(item)}
          >
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <strong>#{item.id}</strong>
                <span className="ms-2">
                  <Badge bg={getPriorityBadgeVariant(item.priority)}>
                    {item.priority === "high"
                      ? "Yüksek"
                      : item.priority === "medium"
                        ? "Orta"
                        : "Düşük"}
                  </Badge>
                </span>
              </div>
              <AlarmStatusBadge status={item.alarmStatus || "Open"} />
            </Card.Header>
            <Card.Body>
              <p className="mb-2">{item.message}</p>
              <p className="text-muted small mb-1">
                <strong>Etiket:</strong> {item.tagName}
              </p>
              <p className="text-muted small mb-1">
                <strong>Tarih:</strong> {formatDate(item.date)}
                <span className="ms-2">({item.timeElapsed} önce)</span>
              </p>
              {item.assignedTo && (
                <p className="text-muted small mb-0">
                  <strong>Atanan:</strong> {item.assignedTo}
                </p>
              )}
            </Card.Body>
            <Card.Footer className="d-flex justify-content-between">
              <small className="text-muted">
                {item.confirm_ === 1 ? (
                  <Badge bg="success">
                    <CheckCircleFill className="me-1" /> Onaylandı
                  </Badge>
                ) : (
                  <Badge bg="warning" text="dark">
                    <XCircleFill className="me-1" /> Onaylanmadı
                  </Badge>
                )}
              </small>
              <ButtonGroup size="sm">
                <Button
                  variant={
                    item.confirm_ !== 1 ? "outline-success" : "outline-warning"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    updateAlarm(item, item.confirm_ !== 1);
                  }}
                >
                  {item.confirm_ !== 1 ? <CheckCircleFill /> : <XCircleFill />}
                </Button>
                <Button
                  variant="outline-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    showDetails(item);
                  }}
                >
                  <Info />
                </Button>
              </ButtonGroup>
            </Card.Footer>
          </Card>
        ))}
      </div>

      {/* Alarm Detail Modal */}
      <Modal show={showDetailModal} onHide={handleCloseModal} size="lg">
        {selectedAlarm && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>
                Alarm #{selectedAlarm.id} Detayı
                <Badge
                  bg={getPriorityBadgeVariant(selectedAlarm.priority)}
                  className="ms-2"
                >
                  {selectedAlarm.priority === "high"
                    ? "Yüksek"
                    : selectedAlarm.priority === "medium"
                      ? "Orta"
                      : "Düşük"}
                </Badge>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {detailsLoading ? (
                <div className="text-center p-4">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-3">Detaylar yükleniyor...</p>
                </div>
              ) : (
                <>
                  <Row className="mb-3">
                    <Col md={6}>
                      <p>
                        <strong>Mesaj:</strong> {selectedAlarm.message}
                      </p>
                      <p>
                        <strong>Etiket Adı:</strong> {selectedAlarm.tagName}
                      </p>
                      <p>
                        <strong>Etiket ID:</strong> {selectedAlarm.tagId}
                      </p>
                      <p>
                        <strong>Durum Kodu:</strong> {selectedAlarm.statusCode}
                      </p>
                      <p>
                        <strong>Onay Durumu:</strong>{" "}
                        {selectedAlarm.confirm_ === 1 ? (
                          <Badge bg="success">
                            <CheckCircleFill className="me-1" /> Onaylandı
                          </Badge>
                        ) : (
                          <Badge bg="warning" text="dark">
                            <XCircleFill className="me-1" /> Onaylanmadı
                          </Badge>
                        )}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <strong>Oluşturulma Tarihi:</strong>{" "}
                        {formatDate(selectedAlarm.date)}
                      </p>
                      <p>
                        <strong>Geçen Süre:</strong> {selectedAlarm.timeElapsed}
                      </p>
                      <p>
                        <strong>Etiket Değeri:</strong>{" "}
                        {selectedAlarm.tagValue || "N/A"}
                      </p>
                      <p>
                        <strong>Atanan Kişi:</strong>{" "}
                        {selectedAlarm.assignedTo || "Atanmadı"}
                      </p>
                      <p>
                        <strong>Durum:</strong>{" "}
                        <AlarmStatusBadge
                          status={selectedAlarm.alarmStatus || "Open"}
                        />
                      </p>
                    </Col>
                  </Row>

                  <AlarmDetailTabs
                    alarm={selectedAlarm}
                    onAlarmStatusChange={(newStatus) => {
                      updateAlarmStatus(selectedAlarm, newStatus);
                      setSelectedAlarm((prev) => ({
                        ...prev,
                        alarmStatus: newStatus,
                      }));
                    }}
                    onAlarmNotesUpdate={(notes, assignedTo) => {
                      updateAlarmNotes(selectedAlarm, notes, assignedTo);
                      setSelectedAlarm((prev) => ({
                        ...prev,
                        notes,
                        assignedTo,
                      }));
                    }}
                    ucerId={ucerId}
                  />
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Kapat
              </Button>
              <Button
                style={{ pointerEvents: alarm_yazma ? "all" : "none" }}
                variant={selectedAlarm.confirm_ !== 1 ? "success" : "warning"}
                onClick={() => {
                  if (alarm_yazma) {
                    updateAlarm(selectedAlarm, selectedAlarm.confirm_ !== 1);
                    setShowDetailModal(false);
                  }

                }}
              >
                {selectedAlarm.confirm_ !== 1 ? (
                  <>
                    <CheckCircleFill className="me-1" /> Onayla
                  </>
                ) : (
                  <>
                    <XCircleFill className="me-1" /> Onayı Kaldır
                  </>
                )}
              </Button>
              <Button
                variant="primary"
                style={{ pointerEvents: alarm_yazma ? "all" : "none" }}

                onClick={() => {
                  if (alarm_yazma) {
                    const notesInput =
                      document.getElementById("notesInput").value;
                    const assignedToInput =
                      document.getElementById("assignedToInput").value;
                    updateAlarmNotes(selectedAlarm, notesInput, assignedToInput);
                    setShowDetailModal(false);
                  }

                }}
              >
                Kaydet
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>

      {/* Work Order Creation Modal */}
      <WorkOrderCreationModal
        show={showWorkOrderCreationModal}
        onHide={() => setShowWorkOrderCreationModal(false)}
        alarmStatusChangeRequest={alarmStatusChangeRequest}
        onWorkOrderCreated={(workOrderId) => {
          // İş emri oluşturulduktan sonra yapılacak işlemler
          if (alarmStatusChangeRequest && alarm_yazma) {
            // Alarm durumunu güncelle
            updateAlarmStatus(
              alarmStatusChangeRequest.alarm,
              alarmStatusChangeRequest.targetStatus,
              `İş emri #${workOrderId} oluşturuldu.`
            ).then(() => {
              // İstek bilgilerini temizle
              setAlarmStatusChangeRequest(null);
            });
          }

          // Modal'ı kapat
          setShowWorkOrderCreationModal(false);

          // Detay görünümündeyse, oluşturulan iş emrini getir
          if (selectedAlarm) {
            fetchWorkOrderById(workOrderId).then((workOrder) => {
              if (workOrder) {
                setSelectedAlarm((prev) => ({
                  ...prev,
                  workOrder,
                }));
              }
            });
          }
        }}
        onCancel={() => {
          setShowWorkOrderCreationModal(false);
          setAlarmStatusChangeRequest(null);
        }}
      />

      {/* Closing Notes Modal */}
      <ClosingNotesModal
        show={showClosingNotesModal}
        onHide={() => {
          setShowClosingNotesModal(false);
          setAlarmStatusChangeRequest(null);
          setClosingNotes("");
        }}
        notes={closingNotes}
        setNotes={setClosingNotes}
        onSubmit={handleClosingNotesSubmit}
      />
    </div>
  );
};


const MapStateToProps = (state) => {
  return {
    temp_com_id: state.project_reducer.temp_com_id,
    uid: state.auth_reducer.user_id,
    users_list: state.project_reducer.users_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,

  }
}


export default connect(MapStateToProps)(Alarm);
